
<v-toolbar color="primary">
  <v-btn icon :to="homeLink">
    <v-icon>home</v-icon>
  </v-btn>
  <v-spacer></v-spacer>
  <img class="logo" src="/api/logo">
  <v-spacer></v-spacer>
  <v-toolbar-items class="toolbar-right">
    <v-btn-toggle v-if="activeLanguages.length > 1" v-model="currentLocale" mandatory dense class="lang-toggle">
      <v-btn
          v-for="lang in activeLanguages"
          :key="lang.code"
          :value="lang.code"
          small
          text
          class="lang-btn"
          :title="lang.displayName"
      >
        <img :src="flagSrc(lang.flag)" :alt="lang.displayName" class="flag-icon" />
      </v-btn>
    </v-btn-toggle>
    <v-btn :class="{hidden: ! hasImages}" text to="/basket">
      <v-badge overlap bottom color="red">
        <template v-slot:badge color="white">{{ basketBadge }}</template>
        <v-icon>shopping_cart</v-icon>
      </v-badge>
    </v-btn>
  </v-toolbar-items>
</v-toolbar>
